module.exports = __webpack_public_path__ + "img/no-result-analise-credito.405f1952.png";